import { CurrencyPipe, DecimalPipe, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { FuseCardComponent } from '@fuse/components/card';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SlideBannerType01Component } from "../../slide-banner/slide-banner-type01/slide-banner-type01.component";

@Component({
    selector: 'app-deals-type01',
    standalone: true,
    imports: [
        MatIconModule,
        MatProgressSpinnerModule,
        CurrencyPipe,
        DecimalPipe,
        NgClass,
        RouterLink,
        HeadingSectionType01Component,
        FuseCardComponent,
        SlickCarouselModule,
        SlideBannerType01Component
    ],
    templateUrl: './deals-type01.component.html',
    styleUrl: './deals-type01.component.scss',
})
export class DealsType01Component {
    @Input() isLandingPage: boolean = false;
    
    public view: any = {
        loadingDeals: true,
        deals: []
    };

    /** Display currency (NAD for site 72, else ZAR). */
    get displayCurrencyCode(): string {
        return this.view?.site?.displayCurrencyCode || 'ZAR';
    }

    constructor(private _tfmService: TFMService) {
        this._tfmService
            .filterBundles({ rateType: 'pps', onlyActive: true }, false)
            .then((res) => {
                this.view.bundles = res;

                let deals;

                // Check for Array
                if (Array.isArray(this.view.bundles.content)) {
                    deals = this.view.bundles.content;
                }

                //Convert to Array
                else {
                    deals = Object.values(this.view.bundles.content);
                }
                deals.forEach((d) => {
                    if (!d.slug)
                        d.slug = d.name.toLowerCase().replaceAll(' ', '-');
                });
                // Get the cheapest deals first
                // deals.sort((a, b) => a.priceAdvertise - b.priceAdvertise);

                //randomize Deals
                //deals.sort(() => Math.random() - 0.5);

                // Get first 4 deals
                this.view.deals = deals.slice(0, 6);
                // Sort the first 6 deals - Latest deals
                this.view.deals.sort((a, b) => a.priceAdvertise - b.priceAdvertise);
                this._tfmService.log('deals', this.view.deals);
            })
            .catch(() => {
                this.view.deals = [];
            })
            .finally(() => {
                this.view.loadingDeals = false;
            });
    }
    ngOnInit(): void {
        this._tfmService.getSite().then((res) => {
            this.view.site = res;

            this._tfmService.getContentBySection('leisure-travel').then((res) => {
                this.view.page = res;
                const images = this.view.page?.content?.images;
                this._tfmService.log("Deals Page:", this.view.page);
            });

            this.view.site.profile = this._tfmService.getSiteProfile(
                this.view.site.profileID
            );
        });
    }
    slideConfig = {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    // addSlide() {
    //   this.slides.push({img: "http://placehold.it/350x150/777777"})
    // }

    // removeSlide() {
    //   this.slides.length = this.slides.length - 1;
    // }

    slickInit(e) {
        // this._tfmService.log('slick initialized');
    }

    breakpoint(e) {
        // this._tfmService.log('breakpoint');
    }

    afterChange(e) {
        // this._tfmService.log('afterChange');
    }

    beforeChange(e) {
        // this._tfmService.log('beforeChange');
    }
    // getUrl(item) {
    //     var url = '';

    //     if (item.isEvent || item.isFeed) {
    //         return null;
    //     }

    //     if (item.supplier && item.search) {
    //         url += '/';
    //         url +=
    //             item.itineraryID == 0
    //                 ? this.transform(item.supplier.place)
    //                 : this.transform(item.destination);
    //         url += '/';
    //         url +=
    //             item.itineraryID == 0
    //                 ? this.transform(item.supplier.name)
    //                 : this.transform(item.search.name);
    //         url += '/' + item.id;

    //         if (this.view.isPromo) url += '/promo';
    //     } else if (item && item.search) {
    //         url += '/';
    //         url += this.transform(item.destination);
    //         url += '/';
    //         url += this.transform(item.search.name);
    //         url += '/' + item.id;

    //         if (this.view.isPromo) url += '/promo';
    //     } else {
    //         url = null;
    //     }

    //     return url;
    // }
    isString(value: any) {
        return typeof value === 'string';
    }
    slugify(text: string): string {
      return text
        .toLowerCase()
        .trim()
        .replace(/[\s\W-|]+/g, '-'); // Replace spaces and non-word characters with a hyphen
    }
}
